import "../assets/NcAppSettingsSection-ahfdhix_.css";
import { n as s } from "../chunks/_plugin-vue2_normalizer-u6G_3nkj.mjs";
const n = {
  name: "NcAppSettingsSection",
  inject: ["registerSection", "unregisterSection"],
  props: {
    name: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0,
      validator(e) {
        return /^[a-z0-9\-_]+$/.test(e);
      }
    }
  },
  computed: {
    // generate an id for each settingssection based on the name without whitespaces
    htmlId() {
      return "settings-section_" + this.id;
    }
  },
  // Reactive changes for section navigation
  watch: {
    id(e, t) {
      this.unregisterSection(t), this.registerSection(e, this.name, this.$slots?.icon);
    },
    name(e) {
      this.unregisterSection(this.id), this.registerSection(this.id, e, this.$slots?.icon);
    }
  },
  mounted() {
    this.registerSection(this.id, this.name, this.$slots?.icon);
  },
  beforeDestroy() {
    this.unregisterSection(this.id);
  }
};
var r = function() {
  var t = this, i = t._self._c;
  return i("div", { staticClass: "app-settings-section", attrs: { id: t.htmlId } }, [i("h3", { staticClass: "app-settings-section__name" }, [t._v(" " + t._s(t.name) + " ")]), t._t("default"), t._e()], 2);
}, o = [], c = /* @__PURE__ */ s(
  n,
  r,
  o,
  !1,
  null,
  "5162e6df",
  null,
  null
);
const _ = c.exports;
export {
  _ as default
};
